/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StoryImage } from './StoryImage';
export type Story = {
    storyId?: number;
    stayFk?: number;
    tourFk?: number;
    title?: string;
    content?: string;
    rating?: number;
    storyDate?: number;
    sharingMode?: Story.sharingMode;
    storyImages?: Array<StoryImage>;
    readonly owner?: string;
    readonly tourPublic?: boolean;
};
export namespace Story {
    export enum sharingMode {
        PRIVATE = 'PRIVATE',
        PUBLIC = 'PUBLIC',
    }
}

